import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/auth/api/auth.service';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { CustomerTableDto } from 'src/app/entity/customerTableDto';
import { MatTableDataSource } from '@angular/material/table';
import { PaginationObject } from 'src/app/contracts/pagination';
import { CustomerDetailDto } from 'src/app/entity/customerDetailDto';
import { CustomerWizardDto } from '../entity/customerWizardDto';

@Injectable({
  providedIn: 'root',
})
export class CustomerService {
  constructor(
    private httpClient: HttpClient,
    private router: Router,
    private authService: AuthService
  ) {}

  getCustomers(): Observable<CustomerTableDto[]> {
    const requestUrl =
      environment.backendUrl + 'api/Customer/GetCustomersPanel/';
    const authHeader = this.authService.getHttpAuthorizationHeader();

    return this.httpClient.get<CustomerTableDto[]>(requestUrl, {
      headers: authHeader,
    });
  }

  getCustomerDetails(id: number): Observable<CustomerDetailDto> {
    const requestUrl =
      environment.backendUrl + 'api/Customer/GetCustomerDetails/' + id;
    const authHeader = this.authService.getHttpAuthorizationHeader();

    return this.httpClient.get<CustomerDetailDto>(requestUrl, {
      headers: authHeader,
    });
  }

  createCustomer(customerDto: CustomerWizardDto): any {
    const requestUrl =
      environment.backendUrl + 'api/Customer/CreateCustomerWizard/';
    const authHeader = this.authService.getHttpAuthorizationHeader();
    return this.httpClient.post<CustomerWizardDto>(requestUrl, customerDto, {
      headers: authHeader,
    });
  }

  updateCustomer(customerDto: CustomerWizardDto): any {
    const requestUrl =
      environment.backendUrl + 'api/Customer/EditCustomerWizard/';
    const authHeader = this.authService.getHttpAuthorizationHeader();
    return this.httpClient.put<CustomerWizardDto>(requestUrl, customerDto, {
      headers: authHeader,
    });
  }
}
